import React from "react";

export default function ImgView() {
  return (
    <div className="d-inline-block content-text position-relative">
      <img
        className="d-block d-xl-none" // opacity-80
        width="100%"
        src="/img/info/info_view.jpg"
        alt="view"
      />
      <span
        className="vw-100 d-none d-xl-block" // opacity-80
        style={{
          background: "url(/img/info/info_view.jpg) 50% 50% / cover no-repeat",
          height: "40vh",
          maxHeight: "860px",
        }}
      />
      <div
        className="w-100 h-100 opacity-mask position-absolute"
        style={{
          top: 0,
          left: 0,
          zIndex: 2,
          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(19, 22, 56,0.4))",
        }}
      />
    </div>
  );
}
